var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.433 2.485A1.612 1.612 0 0 1 5.606 2h1.25c.92 0 1.798.712 1.957 1.588l.079.433c.08.436-.027.849-.3 1.162-.273.314-.675.487-1.133.487H5.845a1.8 1.8 0 0 1-.641-.12l.171 1.415c.165-.067.347-.103.537-.103h1.84c.79 0 1.564.607 1.727 1.352l1.628 7.41 7.678-.532c.415-.029.761.107.976.374.201.25.26.585.166.944l-.893 3.395c-.193.736-.99 1.334-1.775 1.334H7.447c-.797 0-1.513-.622-1.597-1.387L4.59 8.282a1.335 1.335 0 0 1-.005-.195l-.43-3.557c-.062-.153-.1-.316-.113-.485l-.028-.396a1.499 1.499 0 0 1 .42-1.164z",
    fill: "#525266"
  })));
};
export default __webpack_public_path__ + "static/media/icon-seat.17f35f4e.svg";
export { SvgComponent as ReactComponent };